import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { css } from '@linaria/core'
import { boolAttr } from '@fs/zion-frontend-friends'
import { i18n } from '@fs/zion-locale'
import { Link } from '@fs/zion-router'
import { colors, LayoutBand, Row, Separator, usePageWidth } from '@fs/zion-ui'
import { targetEnv } from '@fs/zion-config'

const footerCss = css`
  border-top: 1px solid ${colors.gray10};
  min-height: 80px;
  background-color: ${colors.gray02};

  .footer-text {
    font-size: 12px;
    color: ${colors.gray60};

    &[is-mobile] {
      text-align: center;
    }

    a,
    a:visited {
      color: ${colors.gray90} !important;
      text-decoration-color: ${colors.gray90} !important;
    }
  }
`
const imageCss = css`
  display: block;
  width: auto;
  height: 65px;
  margin: 0 -16px;
  max-width: 300px;
`

function Copyright() {
  const [t] = useTranslation()
  const year = new Date().getFullYear()
  return (
    <>
      {t('footer.copyright-notice', '© {year} by Intellectual Reserve, Inc. All rights reserved.', {
        year,
      })}{' '}
      {t('footer.service-by-church.text', 'A service provided by The Church of Jesus Christ of Latter-day Saints.')}
    </>
  )
}

function LegalLink({ defaults, values, i18nKey, to, linkName }) {
  return (
    <Trans
      i18nKey={i18nKey}
      defaults={defaults}
      components={[<Link to={to} linkName={linkName} external wayfinding target="_blank" />]}
      values={values}
    />
  )
}

export function Legal() {
  const legalRoot = `https://cf.familysearch.org/${i18n.language}/cfprgm/legal`
  const pageWidth = usePageWidth()
  const isMobile = pageWidth({ default: true, sm: false })
  return (
    <div className="footer-text" is-mobile={boolAttr(isMobile)}>
      <div>
        <LegalLink
          i18nKey="fatFooter.terms-of-use"
          to={`${legalRoot}/terms`}
          defaults="FamilySearch <0>Terms of Use</0>"
        />{' '}
        &nbsp;|&nbsp;
        <LegalLink
          i18nKey="fatFooter.privacy-notice"
          to={`${legalRoot}/privacy`}
          defaults="<0>Privacy Notice</0>"
        />{' '}
      </div>
      <div>
        <Copyright />
      </div>
    </div>
  )
}

const subdomains = {
  beta: `beta`,
  int: `integration`,
  local: `cf`,
  prod: `cf`,
}
const churchLogoUrl = `https://${subdomains[targetEnv]}.familysearch.org/${i18n.language}${['beta', 'int'].includes(targetEnv) ? '/eurona' : ''}/cfprgm/service/church-logo/${i18n.language}.svg`

function ChurchLogo() {
  const [t] = useTranslation()
  return (
    <img
      className={imageCss}
      src={churchLogoUrl}
      alt={t('footer.service-by-church.text', 'A service provided by The Church of Jesus Christ of Latter-day Saints.')}
    />
  )
}

export default function Footer() {
  const pageWidth = usePageWidth()
  const separatorSize = pageWidth({ default: 'xs', xl: '' })
  const isMobile = pageWidth({ default: true, sm: false })
  return (
    <div className={footerCss}>
      <LayoutBand>
        {separatorSize && <Separator size={separatorSize} />}
        {isMobile ? (
          <Row alignX="center" wrap>
            <ChurchLogo alignX="end" />
            <Legal />
          </Row>
        ) : (
          <Row alignY="middle">
            <span growX>
              <Legal />
            </span>
            <span noShrinkX>
              <ChurchLogo alignX="end" />
            </span>
          </Row>
        )}
      </LayoutBand>
    </div>
  )
}
